import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const ExternalLoginHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleExternalLogin = async () => {
      try {
        // Get the payload from URL
        const queryParams = new URLSearchParams(window.location.search);
        const payload = queryParams.get('payload');
        
        if (!payload) {
          throw new Error('No login data provided');
        }

        // Decode the payload
        const loginData = JSON.parse(atob(payload));
        
        // Call the login API
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/login_user`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(loginData)
        });

        if (!response.ok) {
          const text = await response.text();
          throw new Error(text || 'Login failed');
        }

        const data = await response.json();
        
        // Save to session storage
        sessionStorage.setItem('token', data.token);
        sessionStorage.setItem('userData', JSON.stringify({
          id: data.user.id,
          email: data.user.email,
          name: data.user.name,
          businessId: data.user.businessId,
          contact: data.user.contact,
            LoginFrom: loginData.LoginFrom,
            LoginUrl: loginData.LoginUrl
        }));

        // Show success and redirect
        await Swal.fire({
          position: "center",
          icon: "success",
          title: "Login Successful",
          showConfirmButton: false,
          timer: 1500
        });
        
        navigate('/dashboard');
        
      } catch (error) {
        console.error('External login error:', error);
        await Swal.fire({
          position: "center",
          icon: "error",
          title: "Login Failed",
          text: error.message || 'An error occurred during login',
          showConfirmButton: true
        });
        navigate('/login');
      }
    };

    handleExternalLogin();
  }, [navigate]);

  return (
    <div className="preloader">
    <div className="frame">
        <div className="center">
            <div className="dot-1"></div>
            <div className="dot-2"></div>

        </div>
    </div>
</div>
  );
};

export default ExternalLoginHandler;